module.exports = __webpack_public_path__ + "static/discord-integration-3-f22081a2031d653341576bea85d88ccd.svg";